import { useEffect, useState } from "react";

import config from "config/appConfig";

const getScreenWidth = () => {
	return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
};

const getScreenHeight = () => {
	return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight;
};

const useResize = () => {
	const [isMobile, setIsMobile] = useState(false);
	const [width, setWidth] = useState(getScreenWidth());
	const [height, setHeight] = useState(getScreenHeight());

	useEffect(() => {
		const onResize = () => {
			setIsMobile(getScreenWidth() <= config.sizes.mobile);
			setWidth(getScreenWidth());
			setHeight(getScreenHeight());
		};

		window.addEventListener("resize", onResize);
		setTimeout(() => {
			onResize();
		}, 150);

		return () => {
			window.removeEventListener("resize", onResize);
		};
	}, []);

	return { isMobile, width, height };
};

export default useResize;
